import colorPicker from "modules/colorPicker";
import color from "modules/color";
import stylesheet from "modules/stylesheet";

module.exports = {
  Color: color,
  ColorPicker: colorPicker,
  Stylesheet: stylesheet,
  // for backwards compat
  ColorWheel: colorPicker,
};



// WEBPACK FOOTER //
// ./iro.js